const state = {
    userid:'',
    isLoading:false,
    school:''
  }

export default state


// WEBPACK FOOTER //
// ./src/store/state.js